function curveOffset(point, direction, offset) {
  if(direction === 'up') {
    return (point - offset);
  } else {
    return (point + offset);
  }
}

function drawRoadPath(ctx, scaleX, scaleY, RP, LP, CP, logicalWidth, step) {
  // Define Logical Coordinates and Styling
  const LINE_WIDTH = window.innerWidth > 1024 ? 70 : 50;
  const LINE_COLOR = '#27BFCC';
  const CURVE_OFFSET = window.innerWidth > 1024 ? 100 : 80;
  
  const startPointX = logicalWidth + 50;
  const startPointY = 50;
  // const avgScale = (scaleX + scaleY) / 2;
  
  for(let i = 1; i <= 5; i++) {
    const vw = window.innerWidth;
    const img = new Image();
    let x, y, h, w;
    const left = vw > 1024 ? LP : LP * 1.5;
    const right = vw > 1024 ? RP * 0.85 : RP * 0.7;
  
    if(i === 1) {
      x = left;
      y = (step * 2.1) - (LINE_WIDTH * 2);
      w = 110
      h = 131;
    } else if(i === 2) {
      x = right;
      y = (step * 4) - (LINE_WIDTH * 2);
      w = 200;
      h = 153;
    } else if(i === 3) {
      x = left;
      y = (step * 5.9) - (LINE_WIDTH * 2);
      w = 200;
      h = 206;
    } else if(i === 4) {
      x = right;
      y = (step * 8.05) - (LINE_WIDTH * 2);
      w = 176;
      h = 176;
    } else if(i === 5) {
      x = left;
      y = (step * 10) - (LINE_WIDTH * 1.5);
      w = 240;
      h = 128;
    }
    img.crossOrigin = 'anonymous';    
    img.src = window.location.origin.replace('http:', 'https:') + '/wp-content/themes/driver-express/svg/road-path-' + i + '.svg';
    img.onload = () => {
      ctx.drawImage(
        img, 
        x, 
        y, 
        vw > 1024 ? w : w * 0.65, 
        vw > 1024 ? h : h * 0.65
      );
    }
  }

  const curvePoints = [
    {
      x1: logicalWidth, y1: 50, // Adjusted x1
      x2: RP, y2: 50,
      x3: RP, y3: 300
    },
    {
      x1: RP, y1: 300,
      x2: RP, y2: curveOffset((step * 2), 'down', CURVE_OFFSET),
      x3: CP, y3: (step * 2)
    },
    {
      x1: CP, y1: (step * 2),
      x2: LP, y2: curveOffset((step * 2), 'up', CURVE_OFFSET),
      x3: LP, y3: (step * 3)
    },
    {
      x1: LP, y1: (step * 3),
      x2: LP, y2: curveOffset((step * 4), 'down', CURVE_OFFSET),
      x3: CP, y3: (step * 4)
    },
    {
      x1: CP, y1: (step * 4),
      x2: RP, y2: curveOffset((step * 4), 'up', CURVE_OFFSET),
      x3: RP, y3: (step * 5)
    },
    {
      x1: RP, y1: (step * 5),
      x2: RP, y2: curveOffset((step * 6), 'down', CURVE_OFFSET),
      x3: CP, y3: (step * 6)
    },
    {
      x1: CP, y1: (step * 6),
      x2: LP, y2: curveOffset((step * 6), 'up', CURVE_OFFSET),
      x3: LP, y3: (step * 7)
    },
    {
      x1: LP, y1: (step * 7),
      x2: LP, y2: curveOffset((step * 8), 'down', CURVE_OFFSET),
      x3: CP, y3: (step * 8)
    },
    {
      x1: CP, y1: (step * 8),
      x2: RP, y2: curveOffset((step * 8), 'up', CURVE_OFFSET),
      x3: RP, y3: (step * 9)
    },
    {
      x1: RP, y1: (step * 9),
      x2: RP, y2: curveOffset((step * 10), 'down', CURVE_OFFSET),
      x3: CP, y3: (step * 10)
    },
    {
      x1: CP, y1: (step * 10),
      x2: 50, y2: curveOffset((step * 10), 'up', CURVE_OFFSET),
      x3: 50, y3: (step * 11)
    },
    {
      x1: 50, y1: (step * 11),
      x2: 50, y2: (step * 12),
      x3: 0, y3: (step * 12)
    }
  ];
  
  // Road Path
  ctx.strokeStyle = LINE_COLOR;
  ctx.lineWidth = LINE_WIDTH; // Use a fixed line width
  ctx.imageSmoothingEnabled = true; // Enable image smoothing to reduce gaps
  ctx.beginPath();
  ctx.moveTo(startPointX, startPointY);
  for (const curvePoint of curvePoints) {
    ctx.bezierCurveTo(curvePoint.x1, curvePoint.y1, curvePoint.x2, curvePoint.y2, curvePoint.x3, curvePoint.y3);
  }
  ctx.stroke();

  // Dotted White Line
  ctx.strokeStyle = '#FFFFFF';
  ctx.setLineDash([20, 20]);
  ctx.lineWidth = 3;
  ctx.beginPath();
  ctx.moveTo(startPointX, startPointY);
  for (const curvePoint of curvePoints) {
    ctx.bezierCurveTo(curvePoint.x1, curvePoint.y1, curvePoint.x2, curvePoint.y2, curvePoint.x3, curvePoint.y3);
  }
  ctx.stroke();
  ctx.setLineDash([]);
}

function setupCanvas(canvas) {
  const stepContainer = document.querySelector('.steps');
  const steps = document.querySelectorAll('.step');
  const stepsContent = document.querySelector('.steps-content');

  if (stepContainer && steps.length > 0) {
    let maxHeight = 0;

    // Find the tallest step
    steps.forEach(step => {
      const stepHeight = step.offsetHeight;
      if (stepHeight > maxHeight) {
        maxHeight = stepHeight;
      }
    });

    // Apply the tallest height to all steps
    steps.forEach(step => {
      step.style.height = maxHeight + 'px';
    });

    // Set Container Height
    stepContainer.style.height = (maxHeight * 9) + 'px';

    // Setup Canvas
    const dpr = window.devicePixelRatio || 1;
    const parent = document.getElementById('steps-container');

    // Define the desired physical size (larger than parent)
    const desiredWidth = parent.offsetWidth + (32 * 16);
    const desiredHeight = parent.offsetHeight + (32 * 16);

    // Set the actual drawing buffer size (scaled for DPR)
    canvas.width = desiredWidth * dpr;
    canvas.height = desiredHeight * dpr;

    // Set the CSS size (displayed size) – no DPR multiplier here
    canvas.style.width = desiredWidth + "px";
    canvas.style.height = desiredHeight + "px";

    // Get Context
    const ctx = canvas.getContext('2d');

    // Reset transform
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    // Calculate logical dimensions based on canvas size
    const logicalWidth = canvas.width / dpr;
    const logicalHeight = canvas.height / dpr;

    // Calculate RP, LP, and CP based on logical width and window width
    const RP = logicalWidth * (window.innerWidth > 1024 ? 0.85 : 0.80);
    const LP = logicalWidth * (window.innerWidth > 1024 ? 0.15 : 0.20);
    const CP = logicalWidth * 0.5;

    // Scale only once: DPR + logical scaling combined
    const scaleX = (canvas.width / dpr) / logicalWidth;
    const scaleY = (canvas.height / dpr) / logicalHeight;
    ctx.scale(scaleX * dpr, scaleY * dpr);
    ctx.imageSmoothingEnabled = true; // Ensure image smoothing is enabled after scaling

    // Position Content
    steps.forEach(step => {
      positionContent(step, logicalWidth, logicalHeight, canvas, scaleX, scaleY);
    });

    stepContainer.style.marginTop = (maxHeight * -1) + 'px';
    // Add null check for stepsContent
    if (stepsContent) {
      stepsContent.style.marginTop = (maxHeight * -1) + 'px';
    }

    // Pass scale factors to adjust line width later
    drawRoadPath(ctx, scaleX, scaleY, RP, LP, CP, logicalWidth, (maxHeight * 0.75));
  }
}

function positionContent(el) {
  const stepNumber = parseInt(el.dataset.step);
  const step = el.offsetHeight;

  if (window.innerWidth > 1024) {
    el.style.left = ( stepNumber % 2 === 0 ? -3 : 3) + 'rem';
    el.style.transform = 'none';
  } else if(window.innerWidth > 400) {
    el.style.left = '50%';
    el.style.transform = 'translateX(-50%)';
  } else {
    el.style.left = '0rem';
    el.style.transform = 'none';
  }

  if(stepNumber === 1) {
    el.style.top = (step * 1.75) + 'px';
  } else if(stepNumber === 2) {
    el.style.top = (step * 3.25) + 'px';
  } else if(stepNumber === 3) {
    el.style.top = (step * 4.75) + 'px';
  } else if(stepNumber === 4) {
    el.style.top = (step * 6.23) + 'px';
  }
}

// Call this function after the DOM is fully loaded or when steps are added/removed
document.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('road-path-canvas');
  if (canvas) {
    setupCanvas(canvas);
    window.addEventListener('resize', () => setupCanvas(canvas));
  }
});
